// extracted by mini-css-extract-plugin
module.exports = {"routeSubtitle":"RouteSubtitle_routeSubtitle__8x1yL","appBarPath":"RouteSubtitle_appBarPath__sukea","appBarSpliter":"RouteSubtitle_appBarSpliter__3AKwR"};